/*=========================================================================================
  File Name: moduleReceiptManagement.js
  Description: Receipt Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleReceiptManagementState.js'
import mutations from './moduleReceiptManagementMutations.js'
import actions from './moduleReceiptManagementActions.js'
import getters from './moduleReceiptManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}